<template>
  <div class="layout">
    <Header
      class="header"
      title="電話自動受付予約（IVR）設定"
      :noIcon="noIcon"
      :showBack="showBack"
      hideStoreName
      :onHome="onHome"
    >
      <div class="store">
        <p>店舗コード：{{ ivrList.gNo }}</p>
        <p>{{ currentStore.name }}</p>
      </div>
    </Header>
    <div class="body">
      <main>
        <slot />
      </main>
    </div>
    <LoadingIndicator v-if="loading || busy" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Header from '@/components/organisms/Header'
import LoadingIndicator from '@/components/molecules/LoadingIndicator'

/**
 * IVR設定画面のレイアウト
 */
export default {
  name: 'IvrLayout',
  components: {
    Header,
    LoadingIndicator,
  },
  props: {
    /** ホーム（戻る）ボタンのイベントハンドラ */
    onHome: Function,
    /** 戻るボタンの表示 */
    showBack: { type: Boolean, default: false },
    /** ボタンの非表示 */
    noIcon: { type: Boolean, default: false },
    /** ロード中の表示 */
    loading: { type: Boolean, default: false },
  },
  computed: {
    ...mapState({
      currentStore: state => state.stores.current.store,
      ivrList: state => state.ivr.list.ivrList,
      busy: state => state.ivr.list.busy,
    }),
  },
}
</script>

<style lang="postcss" scoped>
.layout {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.store {
  display: block;
  font-size: 11px;
  line-height: 1.9;
  padding-right: 16px;
  text-align: right;

  p {
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.body {
  display: flex;
  flex: 1;
  overflow: auto;
}

main {
  flex: 1;
  width: 100%;
}
</style>
